import React from "react";
import {
  Radar,
  RadarChart,
  PolarGrid,
  PolarAngleAxis,
  PolarRadiusAxis,
  ResponsiveContainer,
  Tooltip,
} from "recharts";
import { EMOTIONS, EMOTION_LABELS_TR, EMOTION_EMOJI } from "../lib/constants";

export default function EmotionRadar({ emotions, color = "#EF4444", height = 280 }) {
  const data = EMOTIONS.map((e) => ({
    emotion: `${EMOTION_EMOJI[e]} ${EMOTION_LABELS_TR[e]}`,
    value: emotions?.[e] ?? 0,
    fullMark: 100,
  }));

  return (
    <div style={{ width: "100%", height }} data-testid="emotion-radar">
      <ResponsiveContainer>
        <RadarChart data={data} outerRadius="75%">
          <PolarGrid stroke="#27272A" />
          <PolarAngleAxis
            dataKey="emotion"
            tick={{ fill: "#9CA3AF", fontSize: 11, fontFamily: "JetBrains Mono" }}
          />
          <PolarRadiusAxis
            angle={90}
            domain={[0, 100]}
            tick={{ fill: "#52525B", fontSize: 9 }}
            stroke="#27272A"
          />
          <Radar
            name="Skor"
            dataKey="value"
            stroke={color}
            fill={color}
            fillOpacity={0.35}
            strokeWidth={1.5}
          />
          <Tooltip
            contentStyle={{
              background: "#0A0A0A",
              border: "1px solid #27272A",
              fontFamily: "JetBrains Mono",
              fontSize: 12,
            }}
            labelStyle={{ color: "#F9FAFB" }}
            itemStyle={{ color: color }}
          />
        </RadarChart>
      </ResponsiveContainer>
    </div>
  );
}
